let swiperInstance = null;

function checkAndInitSwiper() {
  const swiperEl = document.querySelector(".block-step__steps.swiper");
  const slides = swiperEl.querySelectorAll(".swiper-slide .block-step__item");

  if (slides.length > 3) {
    swiperEl.classList.remove("fixed-container");
  } else {
    swiperEl.classList.add("fixed-container");
  }
  const totalSlidesWidth = Array.from(slides).reduce((acc, slide) => {
    return acc + slide.offsetWidth;
  }, 0);

  const containerWidth = swiperEl.offsetWidth;
  console.log(totalSlidesWidth, containerWidth);
  if (totalSlidesWidth > containerWidth) {
    swiperEl.classList.remove("fixed-container");
  }
  if (!swiperInstance) {
    console.log("init");

    swiperInstance = new Swiper(swiperEl, {
      slidesPerView: 3,
      spaceBetween: 16,
      breakpoints: {
        1024: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 2,
        },
        0: {
          slidesPerView: 1,
        },
      },
    });
  }
}

document.addEventListener("DOMContentLoaded", checkAndInitSwiper);
